import(/* webpackMode: "eager" */ "/app/apps/landing-app/src/app/global-error.tsx");
